import Validator from "validator";
// Reguler 
export const validateAddHospitalInvoice = (data, files) => {
  // export const validateAddHospitalInvoice = (data) => {
  const errors = {};
  if (!data.invoice_number) {
    errors.invoice_number = "Field is required";
  }

  if (!files.invoice_file) {
    errors.invoice_file = "Field is required";
  }
  if (!data.gls) {
    errors.gls = "File is required";
  }
  if (!files.gl_file) {
    errors.gl_file = "File is required";
  }
  return errors;
};
// export const validateSettingVendor = (data) => {
//   const errors = {};
//   // if (file.file1===1){
//     if (!data.company_siuk) {
//       errors.company_siuk = "Field is required";
//     }
//   if (!data.company_siuk_file) {
//     errors.company_siuk_file = "Field is required";
//   }
// // }
//   return errors;
// };
export const validateVendorSettings = (data) => {
  const errors = {};
  if (!data.company_phone) {
    errors.phone = "Field is required";
  }
  if (!data.company_address) {
    errors.address = "Field is required";
  }
  return errors;
};
export const validateApInvoice = (verification,file,data) => {
  const errors = {};
  if (!verification.c_inv) {
    errors.c_inv = "Required";
  }
  
  // if (file.siuk_file) {
  //   if (!verification.c_siuk) {
  //     errors.c_siuk = "Checked required";
  //   }
  // }
  // if (file.add_file1) {
  //   if (!verification.c_add1) {
  //     errors.c_add1 = "Checked required";
  //   }
  // }
  // if (file.add_file2) {
  //   if (!verification.c_add2) {
  //     errors.c_add2 = "Checked required";
  //   }
  // }
  // if (file.add_file3) {
  //   if (!verification.c_add3) {
  //     errors.c_add3 = "Checked required";
  //   }
  // }
  if (data.cSelected !== undefined && data.cSelected !== 1) {
    if (!data.note) {
      errors.note = "Field is required";
    }
  }
  return errors;
};
export const validateReviewApInvoice = (data) => {
  const errors = {};
  if (!data.decline) {
    errors.decline = "Field selected is required";
  }
  if (!data.note) {
    errors.note = "Field is Required";
  }
  return errors;
};
export const validateApInvoiceHospital = (verification) => {
  // export const validateAddHospitalInvoice = (data) => {
  const errors = {};
  if (!verification.c_inv) {
    errors.c_inv = "Checklist is required";
  }
  if (!verification.c_gl) {
    errors.c_gl = "Checklist is required";
  }
  if (verification.reject===1) {
    if (!verification.note) {
      errors.note = "Field is required";
    }
  }
  if (verification.reject===0) {
    if (!verification.picSite) {
      errors.picSite = "Select region is required";
    }
  }
  return errors;
};
export const validateSapNumber = (doc) => {
  // export const validateAddHospitalInvoice = (data) => {
  const errors = {};
  if (!doc.sap_number) {
    errors.sap_number = "Field is required";
  }
  return errors;
};
export const validateAddStandardInvoice = (data, files) => {
  const errors = {};
  if (!data.purchase_order) {
    errors.purchase_order = "Field is required";
  }
  if (!data.invoice_number) {
    errors.invoice_number = "Field is required";
  }
  if (!data.tax_invoice) {
    errors.tax_invoice = "Field is required";
  }
  if (!data.invoice_amount) {
    errors.invoice_amount = "Field is required";
  }
  if (!files.invoice_file) {
    errors.invoice_file = "Field is required";
  }
  return errors;
};
export const validateOverseasInvoice = (data, files) => {
  const errors = {};
  if (!data.invoice_number) {
    errors.invoice_number = "Field is required";
  }
  if (!data.invoice_amount) {
    errors.invoice_amount = "Field is required";
  }
  if (!files.invoice_file) {
    errors.invoice_file = "Field is required";
  }
  return errors;
};
export const validateFilterPeriod = (actionFilter) => {
  const errors = {};
  if (!actionFilter.from_date) {
    errors.from_date = "Field is required";
  }
  if (!actionFilter.to_date) {
    errors.to_date = "Field is required";
  }

  return errors;
};

export const validateLogin = (data,validation) => {
  const errors = {};
  if (data.email) {
    if (!Validator.isEmail(data.email)) {
      errors.email = "Invalid email";
    }
  } else if (!data.email ) {
    errors.email = "Field is required";
  }
  // if (!validation.captcha ) {
  //   errors.captcha = "Field is required";
  // } 
  // if (validation.captcha && !validation.result ) {
  //   errors.captcha = "Incorrect Captcha";
  // } 
  // console.log(validation)
  if (!data.password) {
    errors.password = "Field is required";
  }
  
  return errors;
};

export const validateCreateNewAccount = (data) => {
  const errors = {};
  if (data.email) {
    if (!Validator.isEmail(data.email)) {
      errors.email = "Invalid email";
    }
  } else if (!data.email) {
    errors.email = "Field is required";
  }
  if (!data.username) {
    errors.username = "Field is required";
  }
  if (!data.password) {
    errors.password = "Field is required";
  }
  if (!data.confirm_password) {
    errors.confirm_password = "Field is required";
  }

  if (data.password !== data.confirm_password) {
    errors.confirm_password = "Not Matching";
  }
  if (!data.company_id) {
    errors.company_id = "Field is required";
  }

  return errors;
};

export const validateAPCreateNewAccount = (dataUser) => {
  const errors = {};
  if (dataUser.email) {
    if (!Validator.isEmail(dataUser.email)) {
      errors.email = "Invalid email";
    }
  } else if (!dataUser.email) {
    errors.email = "Field is required";
  }
  if (!dataUser.username) {
    errors.username = "Field is required";
  }
  if (!dataUser.password) {
    errors.password = "Field is required";
  }
  if (!dataUser.company_id) {
    errors.company_id = "Field is required";
  }

  return errors;
};
export const validateInvoiceRegulerTax = (submit,verification) => {
  const errors = {};
  if (!verification.c_inv) {
    errors.c_inv = "Required";
  }
  // if(!submit.type_invoice){
  //   errors.type_invoice = "Field is required"
  // }
  
  // if (submit.pph === 1) {
  //   if (!submit.type_pph) {
  //     errors.type_pph = "Field is required";
  //       }
  //     }
  // if (submit.pph === 1 && submit.type_pph === "custome_pph") {
  //     if (!submit.custome_type_pph) {
  //         errors.custome_type_pph = "Field is required";
  //       }
  // }

  if (submit.reject === 1) {
    if (!submit.note) {
      errors.note = "Field is required";
    }
  }
  return errors;
};
export const validateCompany = (add) => {
  const errors = {};

  if (!add.company_id) {
    errors.company_id = "Field is required";
  }
  if (!add.company_name) {
    errors.company_name = "Field is required";
  }
  // if (!add.company_phone) {
  //   errors.company_phone = "Field is required";
  // }
  // if (!data.company_address) {
  //   errors.company_address = "Field is required";
  // }

  return errors;
};
export const validateConfigureNow = (data) => {
  const errors = {};
  if (!data.category_id) {
    errors.category_id = "Field is required";
  }
  if (!data.chasis) {
    errors.chasis = "Field is required";
  }
  if (!data.axle) {
    errors.axle = "Field is required";
  }
  if (!data.tank_capacity) {
    errors.tank_capacity = "Field is required";
  }

  return errors;
};
export const validateUser = (data) => {
  const errors = {};
  if (data.email) {
    if (!Validator.isEmail(data.email)) {
      errors.email = "Invalid email";
    }
  } else if (!data.email) {
    errors.email = "Field is required";
  }
  // if (!data.password) {
  //   errors.password = "Field is required";
  // }
  if (!data.username) {
    errors.username = "Field is required";
  }
  // if (!data.role_id) {
  //   errors.role_id = "Field is required";
  // }
  return errors;
};
export const validateQuotations = (data) => {
  const errors = {};

  // if (!data.purchase_timeframe) {
  //   errors.purchase_timeframe = "Field is required";
  // }
  // if (!data.shipping_method) {
  //   errors.shipping_method = "Field is required";
  // }
  // if (data.shipping_method === "Delivery") {
  //   if (!data.country) {
  //     errors.country = "Field is required";
  //   }
  //   if (!data.area) {
  //     errors.area = "Field is required";
  //   }
  // }
  // if (!data.payment_terms) {
  //   errors.payment_terms = "Field is required";
  // }
  if (data.quantity < 1) {
    errors.quantity = "Must be more than 0";
  }
  // if (!data.quantity) {
  //   errors.quantity = "Field is required";
  // }
  // if (!data.freight_terms) {
  //   errors.freight_terms = "Field is required";
  // }
  return errors;
};

export const validateProfileVendor = (data) => {
  const errors = {};
  if (!data.username) {
    errors.password = "Field is required";
  }
  if (data.email_address) {
    if (!Validator.isEmail(data.email_address)) {
      errors.email_address = "Invalid email";
    }
  } 
  else if (!data.email_address) {
    errors.email_address = "Field is required";
  }
  if (!data.old_password) {
    errors.old_password = "Field is required";
  }
  if (!data.new_password) {
    errors.new_password = "Field is required";
  }
  if (!data.confirm_password) {
    errors.confirm_password = "Field is required";
  }
  if (data.confirm_password !== data.new_password) {
    errors.confirm_password = "Confirm password not matching";
  }
  return errors;
};

export const validateProfile = (data) => {
  const errors = {};
  if (!data.username) {
    errors.password = "Field is required";
  }
  if (!data.old_password) {
    errors.old_password = "Field is required";
  }
  if (!data.new_password) {
    errors.new_password = "Field is required";
  }
  if (!data.confirm_password) {
    errors.confirm_password = "Field is required";
  }
  if (data.confirm_password !== data.new_password) {
    errors.confirm_password = "Confirm password not matching";
  }
  return errors;
};
